<template>
  <Scaffold :menus="menus" />
</template>
<script>
import Scaffold from "@/components/layout/Scaffold.vue";

export default {
  components: {
    Scaffold,
  },
  data() {
    return {
      menus: [
        {
          name: "我的业绩",
          path: "/sa/dashboard",
          icon: {
            active: require("@/assets/icons/tab-dashboard-active.svg"),
            inactive: require("@/assets/icons/tab-dashboard-inactive.svg"),
          },
        },
        {
          name: "我的顾客",
          path: "/sa/customers",
          icon: {
            active: require("@/assets/icons/tab-customers-active.svg"),
            inactive: require("@/assets/icons/tab-customers-inactive.svg"),
          },
        },
        {
          name: "全部订单",
          path: "/sa/orders",
          icon: {
            active: require("@/assets/icons/tab-orders-active.svg"),
            inactive: require("@/assets/icons/tab-orders-inactive.svg"),
          },
        },
        {
          name: "我的",
          path: "/sa/my",
          icon: {
            active: require("@/assets/icons/tab-mine-active.svg"),
            inactive: require("@/assets/icons/tab-mine-inactive.svg"),
          },
        },
      ],
    };
  },
};
</script>
